export const applyDrag = (arr, dragResult, oldUniqueIndex) => {
    const { removedIndex, addedIndex, payload } = dragResult;

    if (removedIndex === null && addedIndex === null) {
        return arr;
    }

    const result = [...arr];
    let itemToAdd = payload;
    let itemToDelete = null;

    if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
        itemToDelete = {...itemToAdd};
    }

    if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);

        if (oldUniqueIndex > -1 && removedIndex === null) {
            if (addedIndex > oldUniqueIndex) {
                itemToDelete = result.splice(oldUniqueIndex, 1)[0];
            } else {
                oldUniqueIndex = oldUniqueIndex + 1;
                itemToDelete = result.splice(oldUniqueIndex, 1)[0];
            }
        }
    }

    return { result: result, addedItem: itemToAdd, deletedItem: itemToDelete, swapRemovedIndex: oldUniqueIndex };
};
